export enum Tabs {
  PartnerCompanies = "Partner Companies",
  SearchHiringCompanies = "Search Hiring Companies",
}
